<template>
  <van-popup class="drawer-section" v-model="show" round position="bottom" style="height: 92%;">
    <div class="bar">
      <span @click="cancel">取消</span>
      <span @click="save">保存</span>
    </div>
    <div class="drawer-body">
      <!-- <label class="title">新创建的日程</label> -->
      <van-field 
        class="title" 
        v-model="form.scheduleName" 
        placeholder="添加主题"
      />
      <div class="line"/>
      <!-- 参与者 -->
      <div class="part">
        <div class="icon">
          <van-icon name="friends-o" />
        </div>
        <div class="field">
          <van-field class="newinput" v-model="form.people" placeholder="添加参与者" />
          <div class="line" />
          <van-cell is-link title="参与者权限设置" @click="show1 = true" />
        </div>
      </div>
      <div class="part time">
        <div class="icon">
          <van-icon name="underway-o" />
        </div>
        <div class="field">
          <div class="flex">
            <div class="time-cell" @click="showPicker=true,clickType='start',selectTime=startClock">
              <span>{{startClock}}</span>
              <span>{{dayString}}</span>
            </div>
            <div class="time-cell" @click="showPicker=true,clickType='start', selectTime=endClock">
              <span>{{endClock}}</span>
              <span>{{dayString}}</span>
            </div>
          </div>
          <div class="line" />
          <div class="gray-text">中国标准时间</div>
        </div>
      </div>
      <!-- 飞书 -->
      <div class="part">
        <div class="icon">
          <van-icon name="video-o" />
        </div>
        <div class="field">
          <van-cell is-link title="飞书视频会议" @click="showSwitch = true" />
          <div class="line" />
          <van-cell is-link title="视频会议设置" @click="show2 = true" />
        </div>
      </div>
      <div class="part">
        <div class="icon">
          <van-icon name="notes-o" />
        </div>
        <div class="field">
          <van-field
            v-model="form.userName"
            :label-width="100"
            :is-link="true"
            readonly
          />
          <div class="line" />
          <van-field
            v-model="form.more"
            :label-width="100"
            label="更多选项"
            readonly
          />
        </div>
      </div>
      <div v-if="show3" class="part">
        <div class="icon">
          <van-icon name="award-o" />
        </div>
        <div class="field">
          <van-cell is-link title="提前5分钟" @click="show3 = false">
            <template slot="right-icon">
              <van-icon name="cross" />
            </template>
          </van-cell>
        </div>
      </div>
      <div>
        <van-tabbar v-model="active" :fixed="false">
        <van-tabbar-item icon="hotel-o">会议室</van-tabbar-item>
        <van-tabbar-item icon="location-o">地点</van-tabbar-item>
        <van-tabbar-item icon="sign">签到</van-tabbar-item>
        <van-tabbar-item icon="replay">重复</van-tabbar-item>
        <van-tabbar-item icon="orders-o">描述</van-tabbar-item>
      </van-tabbar>
      </div>
    </div>
    <van-popup v-model="showPicker" position="bottom">
      <van-datetime-picker
        v-model="selectTime"
        type="time"
        title="选择时间"
        :min-hour="0"
        :max-hour="23"
        @confirm="setSelectTime"
        @cancel="showPicker=false"
      />
    </van-popup>
    <van-action-sheet close-on-click-action v-model="show1" :actions="actions1" @select="onSelect1" />
    <van-action-sheet close-on-click-action v-model="show2" :actions="actions2" @select="onSelect2" />
  </van-popup>
</template>
<script>
import moment from 'moment'
import {Toast} from 'vant'
export default {
  props: {
    activeDate: {
      type: moment
    }
  },
  data () {
    return {
      show: false,
      show1: false,
      show2: false,
      show3: true,
      showSwitch: false,
      showPicker: false,
      actions1: [{ name: '修改日程' }, { name: '邀请参与者' }],
      actions2: [{ name: '所有人可加入' }, { name: '仅企业内用户可参加' }, { name: '仅日程参与者可参加' }],
      active: 10,
      dayString: '',
      startClock: '',
      endClock: '',
      clickType: 'start',
      selectTime: null, 
      days: ['日', '一', '二', '三', '四', '五', '六'],
      form: {
        scheduleName: '',
        people: '',
        peopleSet: '',
        userName: localStorage.getItem('username'),
        isOpen: true,
        meetSet: '',
        more: ''
      }
    }
  },
  created () {
    let date = moment(this.activeDate).clone()
    let day = moment(date).format('M-D').replace(/-/, '月') + '日'
    let dayInWeek = `周${this.days[moment(date).day()]}`
    let clock = moment(date).hour()
    this.dayString = `${day} ${dayInWeek}`
    let time = moment(date).startOf('day').add(clock, 'hour')
    this.startClock = moment(time).clone().add(30, 'minute').format('HH:mm')
    this.endClock = moment(time).clone().add(1, 'hour').format('HH:mm')
    console.log(this.startClock, this.endClock)
  },
  methods: {
    init () {
      this.show = true
    },
    onSelect1(item) {
      this.form.peopleSet = item.name
    },
    onSelect2(item) {
      this.form.meetSet = item.name
    },
    setSelectTime(time) {
      this[`${this.clickType}Clock`] = time
      this.showPicker = false
    },
    reset () {
      this.form = {
        scheduleName: '',
        people: '',
        peopleSet: '',
        userName: localStorage.getItem('username'),
        isOpen: true,
        meetSet: '',
        more: ''
      }
    },
    save() {
      if (!this.form.scheduleName) {
        return Toast.fail('请输入主题')
      }
      let query = {
        title: this.form.scheduleName,
        time: `${this.startClock} - ${this.endClock}`
      }
      // 提交数据
      Toast.success('提交成功')
      setTimeout(() => {
        this.$emit('save', query)
        this.reset()
        this.show = false
      }, 300)
    },
    cancel() {
      this.reset()
      this.show = false
    }
  }
}
</script>
<style lang="less" scoped>
.drawer-section {
  font-size: 14px;
  background: #f1f2f4;
}
.line {
  height: 1px;
  background: #ebedf0;
  width: 100%;
  transform: scaleY(.5);
}
.flex {
  display: flex;
}

.bar {
  background: #fff;
  display: flex;
  padding: 16px 14px 0;
  justify-content: space-between;
  span {
    display: inline-block;
    &:nth-child(2) {
      color: #426bef;
    }
  }
}
.title {
  padding-top: 22px;
  background: #fff;
  display: block;
  padding-left: 48px;
  line-height: 60px;
  font-size: 20px;
  font-weight: 600;
}
.drawer-body {
  text-align: left;
  .part {
    background: #fff;
    display: flex;
    justify-items: flex-start;
    margin-bottom: 8px;
    .icon {
      width: 46px;
      height: 44px;
      display: flex;
      justify-content: center;
      align-items: center;
      .van-icon {
        transform: scale(1);
      }
    }
    .field {
      flex: 1;
    }
    &.time {
      .icon {
        height: 60px;
      }
    }
    .time-cell {
      flex: 1;
      padding: 12px 0 10px;
      display: flex;
      flex-direction: column;
      span {
        display: inline-block;
        &:first-child {
          font-weight: 600;
        }
        &:nth-child(2) {
          font-size: 12px;
        }
      }
    }
    .gray-text {
      font-size: 12px;
      color: #9f9fa3;
      line-height: 32px;
    }
  }
}

/deep/ .newinput ::placeholder {
  color: #323233;
} 
/deep/ .van-field.title {
  padding-left: 48px;
  padding-bottom: 0;
}
/deep/ .van-field {
  padding-left: 0;
}
/deep/ .van-cell {
  align-items: center;
  padding-left: 0;
} 
/deep/ .van-cell::after {
  border: none;
}
/deep/ .van-tabbar {
  margin-top: 2px;
  height: 68px;
  transform: scaleX(.95);
  border-radius: 5px;
}

/deep/ .van-tabbar-item {
  transform: scale(.8);
}
</style>


// WEBPACK FOOTER //
// src/components/schedule-list/create-drawer.vue